



// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import io from 'socket.io-client';
// import Header from '../../component/Header';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// const PostDetails = () => {
//   const { postId } = useParams();
//   const navigate = useNavigate();
//   const [post, setPost] = useState(null);
//   const [chat, setChat] = useState([]);
//   const [message, setMessage] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [booking, setBooking] = useState(false);
//   const token = localStorage.getItem('token');
//   const socket = io(process.env.REACT_APP_API_URL.replace('http', 'ws'), {
//     auth: { token },
//   });

//   useEffect(() => {
//     const fetchPost = async () => {
//       if (!token) {
//         toast.error('Please log in to view post details', {
//           position: 'top-right',
//           autoClose: 3000,
//           style: { background: '#F44336', color: 'white' },
//         });
//         navigate('/login');
//         return;
//       }

//       try {
//         setLoading(true);
//         const res = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/search-posts?id=${postId}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         if (res.data && Array.isArray(res.data) && res.data.length > 0) {
//           setPost(res.data[0]);
//         } else {
//           throw new Error('Post not found');
//         }
//       } catch (err) {
//         console.error('Error fetching post:', err);
//         toast.error(err.response?.data?.msg || 'Failed to load post details', {
//           position: 'top-right',
//           autoClose: 3000,
//           style: { background: '#F44336', color: 'white' },
//         });
//         navigate('/notifications');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPost();

//     socket.on('bookingRequest', (data) => {
//       if (data.serviceId) {
//         toast.success('Booking request sent successfully', {
//           position: 'top-right',
//           autoClose: 3000,
//           style: { background: '#4CAF50', color: 'white' },
//         });
//         navigate(`/chat/${data.serviceId}`);
//       }
//     });

//     socket.on('chatMessage', (data) => {
//       if (data.serviceId === postId) {
//         setChat((prev) => [...prev, data]);
//       }
//     });

//     return () => socket.disconnect();
//   }, [postId, token, navigate]);

//   const handleBook = async () => {
//     if (!token) {
//       toast.error('Please log in to book this service', {
//         position: 'top-right',
//         autoClose: 3000,
//         style: { background: '#F44336', color: 'white' },
//       });
//       navigate('/login');
//       return;
//     }

//     try {
//       setBooking(true);
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}oosh/service/book-service`,
//         { postId },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       toast.success(response.data.msg || 'Booking request sent. Waiting for client approval.', {
//         position: 'top-right',
//         autoClose: 3000,
//         style: { background: '#4CAF50', color: 'white' },
//       });
//     } catch (err) {
//       console.error('Error booking service:', err);
//       toast.error(err.response?.data?.msg || 'Failed to book service', {
//         position: 'top-right',
//         autoClose: 3000,
//         style: { background: '#F44336', color: 'white' },
//       });
//     } finally {
//       setBooking(false);
//     }
//   };

//   const handleSendMessage = async (e) => {
//     e.preventDefault();
//     if (!message.trim()) {
//       toast.error('Please enter a message', {
//         position: 'top-right',
//         autoClose: 3000,
//         style: { background: '#F44336', color: 'white' },
//       });
//       return;
//     }

//     try {
//       await axios.post(
//         `${process.env.REACT_APP_API_URL}oosh/service/chat`,
//         { serviceId: postId, message },
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       setMessage('');
//       toast.success('Message sent successfully', {
//         position: 'top-right',
//         autoClose: 3000,
//         style: { background: '#4CAF50', color: 'white' },
//       });
//     } catch (err) {
//       console.error('Error sending message:', err);
//       toast.error(err.response?.data?.msg || 'Failed to send message', {
//         position: 'top-right',
//         autoClose: 3000,
//         style: { background: '#F44336', color: 'white' },
//       });
//     }
//   };

//   if (loading) {
//     return (
//       <div className="h-screen flex items-center justify-center bg-gray-100">
//         <svg
//           className="animate-spin h-8 w-8 text-blue-500"
//           xmlns="http://www.w3.org/2000/svg"
//           fill="none"
//           viewBox="0 0 24 24"
//         >
//           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//           <path
//             className="opacity-75"
//             fill="currentColor"
//             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//           />
//         </svg>
//       </div>
//     );
//   }

//   if (!post) {
//     return <div className="text-center mt-20 text-gray-500">Post not found</div>;
//   }

//   return (
//     <>
//       <Header />
//       <div className="max-w-4xl mt-20 mx-auto p-6 bg-white shadow-md rounded-lg">
//         <ToastContainer />
//         <h2 className="text-2xl font-bold mb-6 text-blue-600">{post.title}</h2>
//         <div className="space-y-4">
//           <p>
//             <strong>Description:</strong> {post.description || 'N/A'}
//           </p>
//           <p>
//             <strong>Type:</strong> {post.type || 'N/A'}
//           </p>
//           <p>
//             <strong>Role Needed:</strong> {post.roleNeeded || 'N/A'}
//           </p>
//           <p>
//             <strong>Budget:</strong> ${post.budget || 'N/A'}
//           </p>
//           <p>
//             <strong>Location:</strong> {post.location || 'N/A'}
//           </p>
//           <p>
//             <strong>Status:</strong> {post.status || 'N/A'}
//           </p>
//           <p>
//             <strong>Posted by:</strong>{' '}
//             {post.clientId ? `${post.clientId.firstName || ''} ${post.clientId.lastName || ''}`.trim() || 'Unknown' : 'N/A'}
//           </p>
//           <p>
//             <strong>Posted on:</strong> {new Date(post.createdAt).toLocaleString()}
//           </p>
//           <button
//             onClick={handleBook}
//             disabled={booking || post.status !== 'open'}
//             className={`p-2 rounded-md text-white ${
//               booking || post.status !== 'open'
//                 ? 'bg-gray-400 cursor-not-allowed'
//                 : 'bg-green-500 hover:bg-green-600'
//             }`}
//           >
//             {booking ? 'Booking...' : 'Book This Job'}
//           </button>
//         </div>
//         {chat.length > 0 && (
//           <div className="mt-6">
//             <h3 className="text-lg font-semibold">Chat</h3>
//             <div className="space-y-2 mt-2">
//               {chat.map((msg, i) => (
//                 <div key={i} className="p-2 bg-gray-100 rounded">
//                   <p>{msg.message}</p>
//                   <p className="text-sm text-gray-500">{new Date(msg.timestamp).toLocaleTimeString()}</p>
//                 </div>
//               ))}
//             </div>
//             <form onSubmit={handleSendMessage} className="mt-4 flex gap-2">
//               <input
//                 type="text"
//                 value={message}
//                 onChange={(e) => setMessage(e.target.value)}
//                 className="p-2 border rounded-md flex-1"
//                 placeholder="Type a message..."
//               />
//               <button
//                 type="submit"
//                 className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600"
//               >
//                 Send
//               </button>
//             </form>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default PostDetails;




import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import io from 'socket.io-client';
import Header from '../../component/Header';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PostDetails = () => {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [chat, setChat] = useState([]);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [booking, setBooking] = useState(false);
  const [distanceInfo, setDistanceInfo] = useState({ distance: null, duration: null, loading: false, error: null });
  const token = localStorage.getItem('token');
  const socket = io(process.env.REACT_APP_API_URL.replace('http', 'ws'), {
    auth: { token },
  });

  useEffect(() => {
    const fetchPostAndProvider = async () => {
      if (!token) {
        toast.error('Please log in to view post details', {
          position: 'top-right',
          autoClose: 3000,
          style: { background: '#F44336', color: 'white' },
        });
        navigate('/login');
        return;
      }

      try {
        setLoading(true);
        // Fetch post details
        const postRes = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/search-posts?id=${postId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (postRes.data && Array.isArray(postRes.data) && postRes.data.length > 0) {
          setPost(postRes.data[0]);
        } else {
          throw new Error('Post not found');
        }

        // Fetch provider details
        const providerRes = await axios.get(`${process.env.REACT_APP_API_URL}oosh/service/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log(providerRes.data.user.address, "your location is here ")
        const providerAddress = providerRes.data.user.address || providerRes.data.user?.location;

        // Calculate distance and travel time if both addresses are available
        if (postRes.data[0].address && providerAddress) {
          setDistanceInfo((prev) => ({ ...prev, loading: true }));
          const response = await axios.get(
            `https://maps.googleapis.com/maps/api/distancematrix/json?origins=${encodeURIComponent(
              providerAddress
            )}&destinations=${encodeURIComponent(postRes.data[0].address)}&mode=driving&units=metric&key=${
              process.env.REACT_APP_GOOGLE_MAPS_API_KEY
            }`
          );

          const result = response.data.rows[0]?.elements[0];
          if (result.status === 'OK') {
            setDistanceInfo({
              distance: result.distance.text, // e.g., "10.5 km"
              duration: result.duration.text, // e.g., "15 mins"
              loading: false,
              error: null,
            });
          } else {
            throw new Error('Unable to calculate distance');
          }
        } else {
          setDistanceInfo({
            distance: null,
            duration: null,
            loading: false,
            error: 'Address information missing',
          });
        }
      } catch (err) {
        console.error('Error fetching data:', err);
        toast.error(err.response?.data?.msg || 'Failed to load post or distance details', {
          position: 'top-right',
          autoClose: 3000,
          style: { background: '#F44336', color: 'white' },
        });
        navigate('/notifications');
      } finally {
        setLoading(false);
        setDistanceInfo((prev) => ({ ...prev, loading: false }));
      }
    };

    fetchPostAndProvider();

    socket.on('bookingRequest', (data) => {
      if (data.serviceId) {
        toast.success('Booking request sent successfully', {
          position: 'top-right',
          autoClose: 3000,
          style: { background: '#4CAF50', color: 'white' },
        });
        navigate(`/chat/${data.serviceId}`);
      }
    });

    socket.on('chatMessage', (data) => {
      if (data.serviceId === postId) {
        setChat((prev) => [...prev, data]);
      }
    });

    return () => socket.disconnect();
  }, [postId, token, navigate]);

  const handleBook = async () => {
    if (!token) {
      toast.error('Please log in to book this service', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#F44336', color: 'white' },
      });
      navigate('/login');
      return;
    }

    try {
      setBooking(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}oosh/service/book-service`,
        { postId },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success(response.data.msg || 'Booking request sent. Waiting for client approval.', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#4CAF50', color: 'white' },
      });
    } catch (err) {
      console.error('Error booking service:', err);
      toast.error(err.response?.data?.msg || 'Failed to book service', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#F44336', color: 'white' },
      });
    } finally {
      setBooking(false);
    }
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();
    if (!message.trim()) {
      toast.error('Please enter a message', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#F44336', color: 'white' },
      });
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}oosh/service/chat`,
        { serviceId: postId, message },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setMessage('');
      toast.success('Message sent successfully', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#4CAF50', color: 'white' },
      });
    } catch (err) {
      console.error('Error sending message:', err);
      toast.error(err.response?.data?.msg || 'Failed to send message', {
        position: 'top-right',
        autoClose: 3000,
        style: { background: '#F44336', color: 'white' },
      });
    }
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-gray-100">
        <svg
          className="animate-spin h-8 w-8 text-blue-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
    );
  }

  if (!post) {
    return <div className="text-center mt-20 text-gray-500">Post not found</div>;
  }

  return (
    <>
      <Header />
      <div className="max-w-4xl mt-20 mx-auto p-6 bg-white shadow-md rounded-lg">
        <ToastContainer />
        <h2 className="text-2xl font-bold mb-6 text-blue-600">{post.title}</h2>
        <div className="space-y-4">
          <p>
            <strong>Description:</strong> {post.description || 'N/A'}
          </p>
          <p>
            <strong>Type:</strong> {post.type || 'N/A'}
          </p>
          <p>
            <strong>Role Needed:</strong> {post.roleNeeded || 'N/A'}
          </p>
          <p>
            <strong>Budget:</strong> ${post.budget || 'N/A'}
          </p>
          <p>
            <strong>Address:</strong> {post.address || post.location || 'N/A'}
          </p>
          {distanceInfo.loading ? (
            <p className="text-gray-500">Calculating distance...</p>
          ) : distanceInfo.error ? (
            <p className="text-red-500">{distanceInfo.error}</p>
          ) : distanceInfo.distance && distanceInfo.duration ? (
            <div>
              <p>
                <strong>Distance to Address:</strong> {distanceInfo.distance}
              </p>
              <p>
                <strong>Estimated Travel Time:</strong> {distanceInfo.duration}
              </p>
            </div>
          ) : null}
          <p>
            <strong>Status:</strong> {post.status || 'N/A'}
          </p>
          <p>
            <strong>Posted by:</strong>{' '}
            {post.clientId ? `${post.clientId.firstName || ''} ${post.clientId.lastName || ''}`.trim() || 'Unknown' : 'N/A'}
          </p>
          <p>
            <strong>Posted on:</strong> {new Date(post.createdAt).toLocaleString()}
          </p>
          <button
            onClick={handleBook}
            disabled={booking || post.status !== 'open'}
            className={`p-2 rounded-md text-white ${
              booking || post.status !== 'open'
                ? 'bg-gray-400 cursor-not-allowed'
                : 'bg-green-500 hover:bg-green-600'
            }`}
          >
            {booking ? 'Booking...' : 'Book This Job'}
          </button>
        </div>
        {chat.length > 0 && (
          <div className="mt-6">
            <h3 className="text-lg font-semibold">Chat</h3>
            <div className="space-y-2 mt-2">
              {chat.map((msg, i) => (
                <div key={i} className="p-2 bg-gray-100 rounded">
                  <p>{msg.message}</p>
                  <p className="text-sm text-gray-500">{new Date(msg.timestamp).toLocaleTimeString()}</p>
                </div>
              ))}
            </div>
            <form onSubmit={handleSendMessage} className="mt-4 flex gap-2">
              <input
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="p-2 border rounded-md flex-1"
                placeholder="Type a message..."
              />
              <button
                type="submit"
                className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-600"
              >
                Send
              </button>
            </form>
          </div>
        )}
      </div>
    </>
  );
};

export default PostDetails;